<template>
    <AdminPageInner v-if="award.id" :breadcrumbs="breadcrumbs">
        <template #heading>Award</template>
        <template v-if="award.id" #links>
            <div class="space-x-4">
                <button
                    v-if="award.user_can.delete"
                    class="ml-4 text-red-600"
                    @click.prevent="confirmDelete">
                    Delete
                </button>
            </div>
        </template>
        <div v-if="award.id" class="row gutters-3 lg:flex-row-reverse">
            <div class="col-full lg:col-auto lg:min-w-96">
                <InfoCard>
                    <InfoCardItem title="Amount">
                        <span :class="award.amount > 0 ? 'text-green-500' : 'text-red-600'">{{ award.amount }}</span>
                    </InfoCardItem>
                    <InfoCardItem title="Date">
                        <CalendarFormat :date="award.created_at"/>
                    </InfoCardItem>
                    <InfoCardItem v-if="award.course_session_id" title="Course">
                        {{ award.course_session.course.title }}
                    </InfoCardItem>
                    <InfoCardItem title="Awarded By">
                        {{ award.awarded_by ? award.awarded_by.name : '-' }}
                    </InfoCardItem>

                </InfoCard>
            </div>
            <div class="col-full mt-6 space-y-6 lg:col lg:mt-0">
                <div class="bg-white p-6 shadow sm:rounded-lg">
                    <h2 class="text-sm leading-5 font-medium text-gray-500">Reason</h2>
                    <div class="mt-2 whitespace-pre-line">
                        {{ award.reason }}
                    </div>
                </div>
            </div>
        </div>
    </AdminPageInner>
</template>

<script>

import axios from "axios";
import AdminPageInner from "@/Components/Layout/AdminPageInner";
import {InfoCard, InfoCardItem} from "@/Components/InfoCard";
import CalendarFormat from "@/Components/CalendarFormat";

export default {

    name: "UserShowPage",

    data() {
        return {
            user: {},
            award: {},
        }
    },

    components: {
        AdminPageInner,
        InfoCard,
        InfoCardItem,
        CalendarFormat
    },

    methods: {
        setData(award) {
            this.award = award;
            this.user = award.user;
        },
        confirmDelete(award) {
            if (window.confirm('Are you sure you want to delete this Award?')) {
                axios.delete(route('api.awards.destroy', award))
                    .then(() => {
                        this.$notify.success('Award deleted');
                        this.$router.push({name: 'admin.users.awards.index', params: {userId: award.user_id}});
                    })
                    .catch(console.error);
            }
        }
    },

    computed: {
        breadcrumbs() {
            return [
                {label: 'Admin', to: {name: 'admin'}},
                {label: 'Users', to: {name: 'admin.users.index'}},
                {
                    label: this.user.name || 'User',
                    to: {name: 'admin.users.show', params: {userId: this.$route.params.userId}}
                },
                {label: 'Awards', to: {name: 'admin.users.awards.index', params: {userId: this.$route.params.userId}}},
                {label: 'Award',
                    to: {
                        name: this.$route.name,
                        params: {userId: this.$route.params.userId, awardId: this.$route.params.awardId}
                    }
                },

            ];
        }
    },

    async beforeRouteEnter(to, from, next) {
        const data = (await axios.get(route('api.awards.show', to.params.awardId), {params: to.query})).data;
        next(vm => vm.setData(data));
    },

    async beforeRouteUpdate(to, from) {
        const data = (await axios.get(route('api.awards.show', to.params.awardId), {params: to.query})).data;
        this.setData(data);
    },
};
</script>
